function assertExists<T, Err extends Error>(
    item: T,
    onFailure: (() => void) | string | Err,
): asserts item is NonNullable<T> {
    if (!item) {
        if (onFailure) {
            if (typeof onFailure === "string") {
                throw new Error(onFailure);
            }
            if (
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ((onFailure as any).prototype &&
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (onFailure as any).prototype instanceof Error) ||
                onFailure instanceof Error
            ) {
                // eslint-disable-next-line @typescript-eslint/only-throw-error
                throw onFailure;
            }
            onFailure();
            return;
        }
        throw new Error("Assertion failed, item does not exist");
    }
}
export { assertExists };
